import { db } from '../config/firebase';
import { collection, doc, getDoc, getDocs, addDoc, updateDoc, query, orderBy, where, serverTimestamp } from 'firebase/firestore';

/**
 * Fetch config document for a custom block
 * Path: customBlockData/{profileId}/{blockType}/config
 */
export const getCustomBlockConfig = async (profileId, blockType) => {
  try {
    const configRef = doc(db, 'customBlockData', profileId, blockType, 'config');
    const snap = await getDoc(configRef);
    return snap.exists() ? snap.data() : null;
  } catch (error) {
    console.error(`Error fetching custom block config (${blockType}):`, error);
    return null;
  }
};

/**
 * Fetch items subcollection for a custom block, ordered by `order` field
 * Path: customBlockData/{profileId}/{blockType}/config/items/{itemId}
 */
export const getCustomBlockItems = async (profileId, blockType) => {
  try {
    const itemsRef = collection(db, 'customBlockData', profileId, blockType, 'config', 'items');
    const q = query(itemsRef, orderBy('order'));
    const snap = await getDocs(q);
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  } catch (error) {
    console.error(`Error fetching custom block items (${blockType}):`, error);
    return [];
  }
};

/**
 * Fetch items filtered by status (e.g., approved endorsements)
 */
export const getCustomBlockItemsByStatus = async (profileId, blockType, status) => {
  try {
    const itemsRef = collection(db, 'customBlockData', profileId, blockType, 'config', 'items');
    const q = query(itemsRef, where('status', '==', status));
    const snap = await getDocs(q);
    const items = snap.docs.map(d => ({ id: d.id, ...d.data() }));
    items.sort((a, b) => (a.order || 999) - (b.order || 999));
    return items;
  } catch (error) {
    console.error(`Error fetching ${status} items (${blockType}):`, error);
    return [];
  }
};

/**
 * Fetch ALL items for a block type (all statuses) — for admin panel
 */
export const getAllCustomBlockItems = async (profileId, blockType) => {
  try {
    const itemsRef = collection(db, 'customBlockData', profileId, blockType, 'config', 'items');
    const snap = await getDocs(itemsRef);
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  } catch (error) {
    console.error(`Error fetching all items (${blockType}):`, error);
    return [];
  }
};

/**
 * Submit a new endorsement (public, no auth required)
 */
export const submitEndorsement = async (profileId, data) => {
  const itemsRef = collection(db, 'customBlockData', profileId, 'endorsement-wall', 'config', 'items');
  return addDoc(itemsRef, {
    ...data,
    status: 'pending',
    submittedAt: serverTimestamp(),
    order: 999,
    profileId,
  });
};

/**
 * Update an endorsement item (admin: approve, reject, edit)
 */
export const updateEndorsementItem = async (profileId, itemId, updates) => {
  const itemRef = doc(db, 'customBlockData', profileId, 'endorsement-wall', 'config', 'items', itemId);
  return updateDoc(itemRef, updates);
};
